import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { obtenerIngresosMensualesACtion, obtenerIngresosReporteAction, obtenerIngresosReporteMetodoPagoAction } from "../../../ducks/reportesDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { makeStyles } from '@material-ui/core/styles'
import { formatDinero } from "./../../../utils/formatDinero"
import { Card, CardContent, Grid, Typography } from "@material-ui/core"
import { FormatoFecha } from "../../../utils/FormatFecha"
import Grafica from "../Utilidad/Grafica"
import GraficaBarras from "../../../global/GraficaBarras"
import ButtonReporteIngresos from "../ButtonReporteIngresos"
const useStyles = makeStyles({
    main: {
        padding: "2%"
    },
    container: {
        display: "flex",
        flexFlow: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
    },
    root: {
        width: '60%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    rootGrafica: {
        width: '40%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 10,
        marginTop: 10,
        padding: 2
    },
})
const useTratarDataMensuales = () => {
    const { metricaIngresosMesnsuales } = useSelector(store => store.reportes)
    const ingresosMensuales = metricaIngresosMesnsuales ?? []
    const labels = ingresosMensuales.map(valor => {
        return `${FormatoFecha({ date: new Date(valor.Anho, valor.Mes - 1), formato: "MMM yyyy" }).toUpperCase()}`
    })
    const data = {
        labels,
        datasets: [
            {
                label: 'Bancarios',
                data: ingresosMensuales.map((valor) => valor.SumaDepBan),
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                stack: 'Stack 0',
            },
            {
                label: 'OpenPay',
                data: ingresosMensuales.map((valor) => valor.SumaOpenPay),
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: 'rgba(54, 162, 235, 1)',
                stack: 'Stack 0',
            },
            {
                label: 'Manuales',
                data: ingresosMensuales.map((valor) => valor.SumaPagManual),
                backgroundColor: 'rgba(255, 206, 86, 0.2)',
                borderColor: 'rgba(255, 206, 86, 1)',
                stack: 'Stack 0',
            },
        ],
    }
    return { labels, data }
}
const useObtenerIngresosMensuales = ({ fechaInicio, fechaFinal }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "Obteniendo información..." }))
        dispatch(obtenerIngresosMensualesACtion({ FechaFin: FormatoFecha({ date: fechaFinal, formato: "MMddyyyy" }), FechaIni: FormatoFecha({ date: fechaInicio, formato: "MMddyyyy" }) })).then(Resposne => {
            dispatch(offLoadAction())
        })
    }, [dispatch, fechaInicio, fechaFinal])
}
const useObtenerIngresos = ({ fechaInicio, fechaFinal }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "Obteniendo información..." }))
        dispatch(obtenerIngresosReporteAction({ FechaFin: FormatoFecha({ date: fechaFinal, formato: "MMddyyyy" }), FechaIni: FormatoFecha({ date: fechaInicio, formato: "MMddyyyy" }) })).then(Resposne => {
            dispatch(offLoadAction())
        })
    }, [dispatch, fechaInicio, fechaFinal])
}
const useObtenerIngresosMetodoPago = ({ fechaInicio, fechaFinal }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "Obteniendo información..." }))
        dispatch(obtenerIngresosReporteMetodoPagoAction({ FechaFin: FormatoFecha({ date: fechaFinal, formato: "MMddyyyy" }), FechaIni: FormatoFecha({ date: fechaInicio, formato: "MMddyyyy" }) })).then(Resposne => {
            dispatch(offLoadAction())
        })
    }, [dispatch, fechaInicio, fechaFinal])
}
const calcularProcentaje = ({ monto, total }) => {
    let resultado = monto * 100
    resultado = resultado / total
    return (resultado < 0) ? resultado * -1 : resultado
}
const sumarIngresos = ({ bancarios, openpay, manual }) => {
    return bancarios + openpay + manual
}
const sumarIngresosPlanPago = ({ cie, tdc, hibrido }) => {
    return cie + tdc + hibrido
}
const Depositos = () => {
    const classes = useStyles()
    const { metricaIngresos, metricaIngresosMetodoPago, ingresoFechaFin, ingresoFechaIncio } = useSelector(store => store.reportes)
    const { data } = useTratarDataMensuales()
    useObtenerIngresos({ fechaFinal: ingresoFechaFin, fechaInicio: ingresoFechaIncio })
    useObtenerIngresosMetodoPago({ fechaFinal: ingresoFechaFin, fechaInicio: ingresoFechaIncio })
    useObtenerIngresosMensuales({ fechaFinal: ingresoFechaFin, fechaInicio: ingresoFechaIncio })
    const totalIngresos = sumarIngresos({ bancarios: metricaIngresos.SumaDepBan, manual: metricaIngresos.SumaPagManual, openpay: metricaIngresos.SumaOpenPay })
    const totalIngresosPlanPago = sumarIngresosPlanPago({ cie: metricaIngresosMetodoPago.SumaCie, hibrido: metricaIngresosMetodoPago.SumaHibrido, tdc: metricaIngresosMetodoPago.SumaTarCredito })

    return (
        <>
            <Grid container spacing={1} alignContent="center" justifyContent="flex-end">
                <ButtonReporteIngresos />
            </Grid>
            <Grid container spacing={1} alignItems="center" justifyContent="center">
                <Grid item xs={6}>
                    <Card>
                        <CardContent>
                            <GraficaBarras data={data} />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.container}>
                        <Card className={classes.root}>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Typography color="textSecondary" variant="h6" >
                                                Ingresos por metodo de pago
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ marginBottom: "0" }}>
                                            <Typography color="textSecondary" variant="subtitle2">
                                                Total de movimientos: {metricaIngresos.MovTotal}
                                            </Typography>
                                        </div>
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Typography color="textSecondary" variant="subtitle2">
                                                Total de Ingresos: {formatDinero(totalIngresos)} MXN
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Grid container>
                                                <Grid item xs={4}>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Depositos Bancarios:
                                                        </Typography>
                                                        <Typography color="textPrimary" >
                                                            {`${metricaIngresos.NumDepBan}`}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Depositos OpenPay:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${metricaIngresos.NumOpenPay}`}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Depositos Manuales:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${metricaIngresos.NumPagManual}`}
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Ingreso Bancarios:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${formatDinero(metricaIngresos.SumaDepBan)} MXN`}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Ingreso OpenPay:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${formatDinero(metricaIngresos.SumaOpenPay)} MXN`}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Ingreso Manuales:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${formatDinero(metricaIngresos.SumaPagManual)} MXN`}
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Card className={classes.rootGrafica}>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={12} >
                                        <div style={{ marginBottom: "1rem", position: "relative", margin: "auto", height: "27vh", width: "27vw" }}>
                                            <Grafica
                                                label="%"
                                                labels={['Bancarios', 'OpenPay', 'Manuales']}
                                                valores={[
                                                    calcularProcentaje({ monto: metricaIngresos.SumaDepBan, total: totalIngresos }),
                                                    calcularProcentaje({ monto: metricaIngresos.SumaOpenPay, total: totalIngresos }),
                                                    calcularProcentaje({ monto: metricaIngresos.SumaPagManual, total: totalIngresos }),
                                                ]}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.container}>
                        <Card className={classes.root}>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Typography color="textSecondary" variant="h6" >
                                                Ingresos por plan de pago
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Typography color="textSecondary" variant="subtitle2">
                                                Total de movimientos: {metricaIngresosMetodoPago.MovTotal}
                                            </Typography>
                                            <Typography color="textSecondary" variant="subtitle2">
                                                Total de Ingresos: {formatDinero(totalIngresosPlanPago)} MXN
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Grid container>
                                                <Grid item xs={4}>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Depositos CIE:
                                                        </Typography>
                                                        <Typography color="textPrimary" >
                                                            {`${metricaIngresosMetodoPago.NumCie}`}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Depositos Hibrido:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${metricaIngresosMetodoPago.NumHibrido}`}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Depositos TDC:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${metricaIngresosMetodoPago.NumTarCredito}`}
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Ingreso CIE:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${formatDinero(metricaIngresosMetodoPago.SumaCie)} MXN`}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Ingreso Hibrido:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${formatDinero(metricaIngresosMetodoPago.SumaHibrido)} MXN`}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Ingreso TDC:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {`${formatDinero(metricaIngresosMetodoPago.SumaTarCredito)} MXN`}
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Card className={classes.rootGrafica}>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={12} >
                                        <div style={{ marginBottom: "1rem", position: "relative", margin: "auto", height: "27vh", width: "27vw" }}>
                                            <Grafica
                                                label="%"
                                                labels={['CIE', 'TDC', 'Hibrido']}
                                                valores={[
                                                    calcularProcentaje({ monto: metricaIngresosMetodoPago.SumaCie, total: totalIngresosPlanPago }),
                                                    calcularProcentaje({ monto: metricaIngresosMetodoPago.SumaTarCredito, total: totalIngresosPlanPago }),
                                                    calcularProcentaje({ monto: metricaIngresosMetodoPago.SumaHibrido, total: totalIngresosPlanPago }),
                                                ]}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}
export default Depositos